import { observable, makeObservable, runInAction, action } from 'mobx';
import { get, post, patch, destroy, deleteById } from 'stores/_services/dataService';

export interface ITableView {
    id?: string;
    tableName?: string;
    viewName: string;
    columns: { visibleColumns: string[]; columnOrder: string[] };
}

export default class TableViewStore {
    items: ITableView[] = [];
    isTableOptionsOpen = false;
    isTriggerSaveView = false;

    constructor() {
        makeObservable(this, {
            items: observable,
            isTableOptionsOpen: observable,
            isTriggerSaveView: observable,
            toggleTableOptions: action
        });
    }

    public saveView(view: ITableView, tableName: string): Promise<any> {
        return view.id ? this._update(view) : this._create(view, tableName);
    }

    public toggleTableOptions = (value?: boolean) => {
        this.isTableOptionsOpen = value !== undefined ? value : !this.isTableOptionsOpen;
    };

    public async getData(userId?: string): Promise<void> {
        try {
            const result = await get<ITableView[]>('/tableview', { filter: { where: { userId } } });

            if (result) {
                runInAction(() => {
                    this.items = result.data;
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    private _create(data: ITableView, tableName: string): Promise<void> {
        try {
            return post('/tableview', { tableName, viewName: data.viewName || 'User Default', columns: data.columns }, { showSuccess: true });
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        }
    }

    private async _update(data: ITableView): Promise<any> {
        try {
            return await patch(`/tableview/${data.id}`, data);
        } catch (e) {
            console.error(e);
            return {};
        }
    }

    private async _deleteById(id: string): Promise<void> {
        try {
            await deleteById(`/tableview/${id}`);
            await this.getData();
        } catch (e) {
            console.error(e);
        }
    }
}
